import React, { useState, Fragment } from 'react'
import { filter, flatMap, map, sumBy, compact } from 'lodash'
import Table from 'UI/Table'
import { arrayToOptions, objectToOptions } from 'Utilities/selectOptions'
import SystemMatcher from './SystemMatcher'
import { defaultFilters, Filters } from './Filters'
import { filteredData } from './Data'

const cloudCoreVirtualWorkstation = asset => (new SystemMatcher(asset)).cloudCore().virtual().workstation().value
const cloudCoreVirtualServer = asset => (new SystemMatcher(asset)).cloudCore().virtual().server().value
const notCloudCorePhysicalWorkstation = asset => (new SystemMatcher(asset)).notCloudCore().physical().workstation().value
const notCloudCorePhysicalServer = asset => (new SystemMatcher(asset)).notCloudCore().physical().server().value
const notCloudCoreVirtualWorkstation = asset => (new SystemMatcher(asset)).notCloudCore().virtual().workstation().value
const notCloudCoreVirtualServer = asset => (new SystemMatcher(asset)).notCloudCore().virtual().server().value

const summaryColumn = (Header, id, filterFunction) => ({
  Header, id, type: 'number',
  accessor: ({ assets }) => filter(assets, asset => filterFunction(asset)).length,
  Footer: ({ data }) => sumBy(data, id)
})

const SystemsSummary = ({ customerAssets, splaScope = false }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const filterOptions = {
    regions: [...arrayToOptions(map(customerAssets, 'region_name')), { label: 'Unknown', value: null }],
    customers: [...arrayToOptions(map(customerAssets, 'customer_name')), { label: 'Unknown', value: null }],
    inCloudCore: [{ value: 'All', label: 'All' }, { value: true, label: 'In CloudCore' }, { value: false, label: 'Not In CloudCore' }],
    systemTypes: arrayToOptions(['VMware', 'Hyper-V']),
    operatingSystems: objectToOptions(flatMap(customerAssets, 'assets'), 'operating_system'),
  }

  return (
    <Fragment>
      <Filters {...{ filterOptions, filters, changeFilters }}/>
      <Table className='-striped -highlight' data={filteredData({ customerAssets, filters })} columns={compact([
        { Header: 'Customer', accessor: 'customer_name', width: 200, type: 'clientNameWithStatus' },
        (splaScope && { Header: 'In Datto', accessor: 'inDatto', type: 'boolean' }),
        (splaScope && { Header: 'Assets In Datto', accessor: 'assetsInDatto', type: 'number' }),
        { Header: 'Total Assets', accessor: ({ assets }) => assets.length, id: 'totalAssets', type: 'number', Footer: ({ data }) => sumBy(data, 'totalAssets') },
        { Header: 'CloudCore', columns: [
          summaryColumn('Workstation OS', 'cloudcoreVirtualWorkStationOS', cloudCoreVirtualWorkstation),
          summaryColumn('Server OS',      'cloudcoreVirtualServerOS',      cloudCoreVirtualServer)
        ]},
        (!splaScope && { Header: 'Non-CloudCore Physical', columns: [
          summaryColumn('Workstation OS', 'nonCloudcorePhysicalWorkStationOS', notCloudCorePhysicalWorkstation),
          summaryColumn('Server OS',      'nonCloudcorePhysicalServerOS',      notCloudCorePhysicalServer)
        ]}),
        (!splaScope && { Header: 'Non-CloudCore Virtual', columns: [
          summaryColumn('Workstation OS', 'nonCloudcoreVirtualWorkStationOS', notCloudCoreVirtualWorkstation),
          summaryColumn('Server OS',      'nonCloudcoreVirtualServerOS',       notCloudCoreVirtualServer)
        ]})
      ])}
      SubComponent={({ original }) => (
        <Table className='-striped -highlight' data={original.assets} columns={compact([
          { Header: 'Name', accessor: 'name' },
          (splaScope && { Header: 'In Datto', accessor: 'inDatto', type: 'boolean' }),
          { Header: 'Power', accessor: 'power_state', type: 'powerState' },
          { Header: 'Virtual/Physical', id: 'isVirtual', accessor: ({ isVirtual }) => isVirtual ? 'Virtual' : 'Physical' },
          { Header: 'Machine Type', accessor: 'category' },
          { Header: 'OS', accessor: 'operating_system' },
          { Header: 'CPU Cores', accessor: 'cores' },
        ])} />
      )}/>
    </Fragment>
  )
}

export default SystemsSummary
